(function () {
  function open(item) {
    var btn = item.querySelector(".fd-faq__question");
    var answer = item.querySelector(".fd-faq__answer");
    item.classList.add("fd-faq__item--open");
    if (btn) btn.setAttribute("aria-expanded", "true");
    if (answer) answer.style.maxHeight = answer.scrollHeight + "px";
  }

  function close(item) {
    var btn = item.querySelector(".fd-faq__question");
    var answer = item.querySelector(".fd-faq__answer");
    item.classList.remove("fd-faq__item--open");
    if (btn) btn.setAttribute("aria-expanded", "false");
    if (answer) {
      answer.style.maxHeight = "0";
      answer.style.padding = "0 24px";
    }
  }

  function initFaqAccordion(wrapper) {
    var items = wrapper.querySelectorAll(".fd-faq__item");
    items.forEach(function (item) {
      var btn = item.querySelector(".fd-faq__question");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("fd-faq__item--open");
        items.forEach(function (other) {
          if (other !== item) close(other);
        });
        if (isOpen) {
          close(item);
        } else {
          open(item);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll("[data-faq-accordion]").forEach(initFaqAccordion);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
